import { projectsApi } from 'api'

export const fetchMe = () =>
  projectsApi.get<{
    persistentPlatformFile: {
      description: string | null
      extension: string | null
      fileKey: string | null
      id: string
      metaData: any
      mimeType: string | null
      name: string
      originalName: string
      size: number | null
      thumbnailUrl: string | null
      type: string | null
      url: string | null
    }
  }>('/users/me')
